import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material'
import {
    Home as HomeIcon,
    Assignment as InspectionsIcon,
    BarChart as DataIcon,
    Notifications as AlertsIcon,
} from '@mui/icons-material'

const BottomNav: React.FC = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const getValue = () => {
        const path = location.pathname
        if (path === '/' || path.startsWith('/apiaries')) return 0
        if (path.startsWith('/inspections')) return 1
        if (path.startsWith('/measurements')) return 2
        if (path.startsWith('/alerts')) return 3
        return -1 // No selection if not one of these
    }

    return (
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000, display: { md: 'none' } }} elevation={3}>
            <BottomNavigation
                showLabels
                value={getValue()}
                onChange={(event, newValue) => {
                    switch (newValue) {
                        case 0:
                            navigate('/')
                            break
                        case 1:
                            navigate('/inspections')
                            break
                        case 2:
                            navigate('/measurements')
                            break
                        case 3:
                            navigate('/alerts')
                            break
                    }
                }}
                sx={{
                    height: '56px',
                    '& .MuiBottomNavigationAction-root': {
                        minWidth: 'auto',
                        padding: '6px 0',
                        fontSize: '0.65rem',
                    },
                    '& .MuiBottomNavigationAction-label': {
                        fontSize: '0.65rem',
                        marginTop: '2px',
                        '&.Mui-selected': {
                            fontSize: '0.7rem',
                        }
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: '1.3rem',
                    },
                    '& .Mui-selected': {
                        color: '#F8B133'
                    }
                }}
            >
                <BottomNavigationAction label="Hives" icon={<HomeIcon />} />
                <BottomNavigationAction label="Inspections" icon={<InspectionsIcon />} />
                <BottomNavigationAction label="Data" icon={<DataIcon />} />
                <BottomNavigationAction label="Alerts" icon={<AlertsIcon />} />
            </BottomNavigation>
        </Paper>
    )
}

export default BottomNav
